<template>
    <div class="modal fade" :id="'file_upload'+this.crew_id" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <form @submit.prevent="upload">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Upload File</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label :for="'covMedCert'+crew_id">Upload Cov19 Medical Certificate</label>
                            <input type="file" class="form-control-file border p-1 rounded" :id="'covMedCert'+crew_id">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-sm tnkc-primary">
                            <font-awesome-icon icon="file-upload"/>
                            Upload
                        </button>
                        <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal">
                            <font-awesome-icon icon="window-close"/>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters,mapActions} from 'vuex';
  import {appMixins} from '../../../mixins/app.mixins';

  export default {
    name: 'file_upload',
    mixins:[appMixins],
    props:{
      crew_id : Number,
      count : Number,
    },

    data(){
      return{
        displayCounts: [10, 15, 20, 50, 100, 200],
        searchKey : 'all', //default
        searchValue: '',
        setActiveKey: '',
        key: '',
        keyPlaceHolder:'',
      }
    },

    methods:{
      ...mapActions(['uploadCov19MedCert','getCrewList']),

      searchCrew(initializePage = null) {
        let page = (initializePage) ? initializePage : this.pagination.currentPage;
        let params = {
          page : page,
          searchKey : this.searchKey,
          searchValue : this.searchValue,
          count : this.count
        }
        this.getCrewList(params);
      },

     async upload(){
        if(await this.questionAlert('Are you sure you want to upload this document.','UPLOAD')){
          const file = document.getElementById(`covMedCert`+this.crew_id).files[0];
          const formData = new FormData();
          formData.append('crew_id',this.crew_id);
          formData.append('file',file);
          this.uploadCov19MedCert(formData).then((response)=>{
            if(response == true){
              this.successAlert('Upload Successfully','Upload');
              this.searchCrew();
              this.resetFileInput();
            }
          }).catch((error)=>{});
        }
      },

      resetFileInput(){
        document.getElementById('covMedCert').value = '';
      },

      //in input files @onChange=""
      /*fileChange(e){
        console.log(e.target.files);
        this.file = e.target.files;
      }*/
    },

    computed:{
      ...mapGetters(['crews','pagination'])
    },

    created() {
      if (!this.crews.length){
        this.searchCrew();
      }
    },

    mounted() {

    },
  };
</script>

<style scoped>

</style>